<template>
  <div class="x-tablelist-view" data-automation="shortMessage">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout1"
      :isBreak="true"
      :data="filter"
      @search="search"
      @input="search"
      @clear="clear"
    ></ux-searchOption>
    <ux-searchOption class="x-button-list" :layout="layout2"></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import imeiInput from '../template/imeiInput';
export default {
  data() {
    return {
      layout1: [
        // 搜索项配置
        {
          type: 'input',
          key: 'serial_num',
          hideBtn: true,
          placeholder: this.$t('HT.orderManage.serialNum.placeholder')
        },
        {
          type: 'select',
          key: 'status',
          options: [],
          placeholder: this.$t('HT.upgradeManage.status.placeholder')
        },
        {
          type: 'date',
          daterange: true,
          time: true
        },
        {
          width: '220px',
          render: (h) => {
            return h(imeiInput, {
              props: {
                value: this.filter.imeis
              },
              on: {
                change: (val) => {
                  this.filter.imeis = val;
                }
              }
            });
          }
        },
        {
          type: 'select',
          key: 'activity',
          options: [],
          placeholder: this.$t('HT.upgradeManage.activity')
        },
        {
          type: 'select',
          key: 'upgrade_status',
          options: [],
          placeholder: this.$t('HT.upgradeManage.upgradeStatus')
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.clear'),
          plain: true,
          show: true,
          event: 'clear'
        }
      ],
      layout2: [
        {
          type: 'button',
          text: this.$t('HT.upgradeManage.cancelingUpdate'),
          show: true,
          size: 'small',
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.checkAll'),
          show: true,
          size: 'small',
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.upgrade'),
          show: true,
          size: 'small',
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.upgrade1'),
          show: true,
          size: 'small',
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.upgradeManage.allCancelingUpdate'),
          show: true,
          size: 'small',
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.exportData'),
          show: true,
          size: 'small',
          event: 'search'
        }
      ],
      columns: [
        // 表头数据
        {
          type: 'selection'
        },
        {
          label: this.$t('HT.orderManage.serialNum'),
          prop: 'serial_num',
          tooltip: true
        },
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeManage.upgradeStatus'),
          prop: 'upgrade_type',
          tooltip: true
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_time',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeManage.upgradeStatus1'),
          prop: 'upgrade_status',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeManage.activity1'),
          prop: 'activity',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        imei: '', // imei号
        serial_num: '',
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    // this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getSign(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 点击搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 点击搜索
     */
    clear() {
      this.filter = {};
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
